/**
 * SEMILLA canon de Alertas (alertas.html, F6): lo que el sistema quiere que
 * el equipo mire YA, con su porqué y su regla — «toda alerta lleva su
 * porqué — o no se envía». El motor que las detecta (SLA vencidos en la
 * cola, casas sin actividad…) llega con F5b; hoy son datos fijos, fieles al
 * canon (2 activas + el rastro de apagadas de la semana).
 */
import type { ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { buttonClass } from "@skein/ui";

/** Rutas a las que puede navegar la acción primaria de una alerta (literales: el router las tipa). */
export type AlertGoTarget = "/cola" | "/implantaciones";

export interface AlertCard {
  id: string;
  kind: ReactNode;
  /** color de peligro sobre el tipo (SLA vencido) — inline como en el contrato, no hay modificador en el sistema. */
  kindDanger?: boolean | undefined;
  sla: ReactNode;
  late?: boolean | undefined;
  title: ReactNode;
  rows: ReadonlyArray<{ k: ReactNode; v: ReactNode }>;
  goLabel: string;
  goTo: AlertGoTarget;
  /** cómo queda al silenciar (difiere hasta mañana — no borra la causa). */
  silenciaToast: string;
}

const casaLink = (id: string, nombre: string) => (
  <Link to="/implantaciones/$id" params={{ id }} className={buttonClass({ variant: "link" })}>{nombre}</Link>
);

export const ALERTAS_SEED: AlertCard[] = [
  {
    id: "sla-vielsa",
    kind: "! sla vencido",
    kindDanger: true,
    sla: "desde las 10:12",
    late: true,
    title: <>La activación de Power BI de {casaLink("eng-vielsa", "Grupo Vielsa")} lleva 2 h fuera de SLA</>,
    rows: [
      { k: "porqué", v: "pedida a las 06:12, verificada a las 09:12 y aún sin registro final; el SLA de activaciones es 4 h" },
      { k: "regla", v: "SLA vencido en la cola → alerta al equipo" },
    ],
    goLabel: "Resolver en la cola",
    goTo: "/cola",
    silenciaToast: "Silenciada hasta mañana — la alerta volverá si sigue sin registro.",
  },
  {
    id: "casas-inactivas",
    kind: "◔ casas sin actividad",
    sla: "regla: 14 días",
    title: "2 casas llevan más de 14 días sin conversar",
    rows: [
      { k: "porqué", v: <><b>Bodegues Roure</b> (16 días) y <b>Congelados Mir</b> (21 días) — el asesor no puede ayudar a quien no le habla</> },
      { k: "regla", v: "sin mensajes 14 días → aviso al equipo, nunca al executive sin decidirlo" },
    ],
    goLabel: "Ver las casas",
    goTo: "/implantaciones",
    silenciaToast: "Silenciada hasta mañana — volverá mientras sigan paradas.",
  },
];

/** Rastro de apagadas esta semana (se apagan solas al resolverse la causa — no las apaga el equipo). */
export const APAGADAS_SEED: ReadonlyArray<{ t: string; children: ReactNode }> = [
  { t: "ayer", children: <><b>draft 48 h sin publicar</b> (salud-financiera) — se apagó al retomarse la edición</> },
  { t: "4 ago", children: <><b>sync de BC fallida</b> a las 05:30 — reintento automático correcto a las 06:10</> },
];
